import React, { useState, useEffect } from 'react';
import api from "../../../services/api";

import Select2 from "react-select2-wrapper";
import {
    Collapse,
    Button,
    CardBody,
    Row,
    Col,
    Input,
    FormGroup,
    InputGroup,
} from "reactstrap";

export default ({ title, notify, load, isOpen, clearTrigger, ...props }) => {

    const [nome, setNome] = useState(null)
    //Flag para definir tempo de execução
    const [runLoad, setRunLoad] = useState(props.search ? props.search : true)
    const [monitorClearFilters, setMonitorClearFilters] = useState(undefined)

    useEffect(() => {
        if (monitorClearFilters) search()
    }, [monitorClearFilters])

    useEffect(() => {
        if (clearTrigger > 0) clearFilters()
    }, [clearTrigger])


    useEffect(() => {
        if (runLoad) {
            search()
            setRunLoad(false)
        }
    }, [runLoad])

    function throwError(text) {
        if (notify) notify('danger', text)
    }

    function clearFilters() {
        setNome('')
        setMonitorClearFilters(Date.now())
    }

    function search() {
        load({
            nome,
        })
    }

    return (
        <Collapse isOpen={isOpen}>
            <CardBody>
                <Row className="py-4">
                    <Col xs="12" lg="4" sm="12" md="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                            >
                                Nome
                                    </label>
                            <Input
                                className="form-control-alternative"
                                placeholder="Nome do perfil..."
                                type="text"
                                value={nome}
                                onChange={(e) => setNome(e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row className='d-flex justify-content-end pr-3'>
                    <Button
                        color="link"
                        onClick={() => clearFilters()}
                        size="sm"
                    >
                        Limpar Filtros
                    </Button>
                    <Button
                        color="secondary"
                        onClick={() => search()}
                        outline
                        size="sm"
                        href="#">
                        <span className="btn-inner--icon">
                            <i className="fa fa-search" />
                        </span>
                        <span className="btn-inner--text"> Pesquisar</span>
                    </Button>
                </Row>
            </CardBody>
        </Collapse>
    );
}
